import React, { useState } from "react";

/* ── Image imports ── */
import HeroBgImg        from "../../../asset/images/defence/hero-bg.webp";
import BcSepIcon        from "../../../asset/images/about/breadcrumb-separator.svg";

/* Smart Borders */
import SmartMainImg     from "../../../asset/images/defence/smart-main.webp";
import SmartThumb1      from "../../../asset/images/defence/smart-thumb1.webp";
import SmartThumb2      from "../../../asset/images/defence/smart-thumb2.webp";
import SmartThumb3      from "../../../asset/images/defence/smart-thumb3.webp";
// import SmartThumb4      from "../../../asset/images/defence/smart-thumb3.webp";

/* Reflex */
// import ReflexDiagram    from "../../../asset/images/defence/reflex-box1.webp";
// import ReflexBox        from "../../../asset/images/defence/reflex-box.webp";

/* Third Eye */
import ThirdEyeMainImg  from "../../../asset/images/defence/thirdeye-main.webp";
import ThirdEyeThumb1   from "../../../asset/images/defence/thirdeye-thumb1.webp";
import ThirdEyeThumb2   from "../../../asset/images/defence/thirdeye-thumb2.webp";
import ThirdEyeThumb3   from "../../../asset/images/defence/thirdeye-thumb3.webp";
import ThirdEyeThumb4   from "../../../asset/images/defence/thirdeye-thumb3.webp";

/* DWEEP */
import DweepMainImg     from "../../../asset/images/defence/dweep-main.webp";
import DweepThumb1      from "../../../asset/images/defence/dweep-thumb1.webp";
import DweepThumb2      from "../../../asset/images/defence/dweep-thumb2.webp";
import DweepThumb3      from "../../../asset/images/defence/dweep-thumb3.webp";
import DweepThumb4      from "../../../asset/images/defence/dweep-thumb4.webp";

/* Specialized Power Sources */
import PowerMainImg     from "../../../asset/images/defence/power-main.webp";
import PowerThumb1      from "../../../asset/images/defence/power-thumb1.webp";
import PowerThumb2      from "../../../asset/images/defence/power-thumb2.webp";
import PowerThumb3      from "../../../asset/images/defence/power-thumb3.webp";
import PowerThumb4      from "../../../asset/images/defence/power-thumb4.webp";
import PowerThumb5      from "../../../asset/images/defence/power-thumb5.webp";
import PowerThumb6      from "../../../asset/images/defence/power-thumb6.webp";
import PowerThumb7      from "../../../asset/images/defence/power-thumb7.webp";
import PowerThumb8      from "../../../asset/images/defence/power-thumb8.webp";

const powerSlides = [
  { main: PowerMainImg, thumbs: [PowerThumb1, PowerThumb2, PowerThumb3, PowerThumb4] },
  { main: PowerThumb5,  thumbs: [PowerThumb5, PowerThumb6, PowerThumb7, PowerThumb8] },
  { main: PowerThumb6,  thumbs: [PowerThumb6, PowerThumb7, PowerThumb8, PowerThumb1] },
];

const NAV_ITEMS = [
  { label: "Smart Borders",       anchor: "ad-smart-borders" },
  
  { label: "Third Eye™ Perimeter",          anchor: "ad-third-eye" },
  { label: "Second Sight™",       anchor: "ad-second-sight" },
  
  { label: "Specialized Power",   anchor: "ad-specialized-power" },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .ad { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══════════════════════════════════════════
     1. HERO
  ══════════════════════════════════════════ */
  .ad-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .ad-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center; display: block;
  }
  .ad-hero-overlay {
    position: absolute; inset: 0;
    background: linear-gradient(to right, rgba(0,0,0,0.68) 0%, rgba(0,0,0,0.30) 60%, rgba(0,0,0,0.08) 100%);
  }
  .ad-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px; max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .ad-hero-title { font-size: 42px; font-weight: 600; color: #fff; line-height: 120%; margin-bottom: 16px; }

  .ad-hero-divider {
    width: 429px; height: 2px;
    background: #EB2019; border: none;
    margin-bottom: 16px;
  }

  .ad-hero-subtitle { font-size: 16px; font-weight: 400; color: rgba(255,255,255,0.80); line-height: 160%; max-width: 429px; }

  /* ══════════════════════════════════════════
     SUBNAV — desktop sticky (HP Series pattern)
  ══════════════════════════════════════════ */
  .ad-subnav {
    width: 100%;
    background: #EB2019;
    position: sticky;
    top: 162px;
    z-index: 100;
    overflow: visible;
  }
  .ad-subnav-inner {
    max-width: 1600px;
    margin: 0 auto;
    // padding: 0 102px;
    display: flex;
    align-items: stretch;
    white-space: nowrap;
    overflow: visible;
    justify-content:center;
  }
  .ad-subnav-item { position: relative; flex-shrink: 0; }
  .ad-subnav-link {
    display: inline-flex;
    align-items: center;
    padding: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s;
    border: 1px solid #A40000;
    background: #B91E1A;
    white-space: nowrap;
    height: 100%;
  }
  .ad-subnav-link.ad-active { font-weight: 500; }
  .ad-subnav-link:hover { background: rgba(0,0,0,0.15); }

  /* scroll anchor offset */
  .ad-anchor { scroll-margin-top: 270px; }

  /* ══════════════════════════════════════════
     MOBILE BAR (hidden on desktop)
  ══════════════════════════════════════════ */
  .ad-mobile-bar {
    display: none;
    width: 100%;
    background: #B91E1A;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 56px;
    position: sticky;
    top: 72px;
    z-index: 100;
  }
  .ad-mobile-bar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .ad-hamburger {
    display: flex;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px;
  }
  .ad-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
  }

  /* ══════════════════════════════════════════
     MOBILE SIDEBAR
  ══════════════════════════════════════════ */
  .ad-sidebar-overlay {
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 500;
  }
  .ad-sidebar-overlay.open { display: block; }
  .ad-sidebar {
    position: fixed;
    top: 80px;
    left: 0;
    width: 275px;
    max-width: 100vw;
    height: 614px;
    background: #fff;
    z-index: 600;
    display: flex;
    flex-direction: column;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
    overflow-y: auto;
    border: 1px solid #7A7A7A;
  }
  .ad-sidebar.open { transform: translateX(0); }
  .ad-sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #B91E1A;
    padding: 0 20px;
    height: 56px;
    flex-shrink: 0;
  }
  .ad-sidebar-header-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }
  .ad-sidebar-close {
    background: none;
    border: none;
    cursor: pointer;
    color: #fff;
    font-size: 22px;
    line-height: 1;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ad-sidebar-nav { flex: 1; overflow-y: auto; }
  .ad-sidebar-row {
    display: flex;
    align-items: center;
    padding: 18px 24px;
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-bottom: 0.7px solid #7A7A7A;
    cursor: pointer;
    background: none;
    width: 100%;
    text-align: left;
    text-decoration: none;
  }
  .ad-sidebar-row:hover { background: #fafafa; }

  /* ══════════════════════════════════════════
     2. BREADCRUMB
  ══════════════════════════════════════════ */
  .ad-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .ad-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap; gap:14px;
  }
  .ad-bc-item {
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px; transition: color 0.15s;
  }
  .ad-bc-item:hover { color: #EB2019; }
  .ad-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%; 
    margin: 0 8px; flex-shrink: 0;
  }
  .ad-bc-item.active { color: #202020; }

  /* ══════════════════════════════════════════
     SHARED
  ══════════════════════════════════════════ */
  .ad-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  .ad-section-heading {
    font-size: 32px; font-weight: 600;
    color: #EB2019; margin-bottom: 60px; line-height: 120%;
  }
  .ad-section-heading1 {
    font-size: 32px; font-weight: 600;
    color: #EB2019; margin-bottom: 20px; line-height: 120%;
  }

  .ad-overlay-box {
    position: absolute;
    margin-top: 30px;
    left: 256px;
    right: 700px;
    background: #F2F5FA;
    border-radius: 0px;
    padding: 24px;
    font-size: 20px; font-weight: 500;
    color: #202020; line-height: 140%;
    z-index: 2;
    max-width: 737px;
  }

  .ad-section-row {
    display: flex; align-items: flex-start; gap: 40px; padding-bottom:80px; border-bottom:1px solid #EB2019;
  }
  .ad-section-left {
    flex: 1 1 0; display: flex; flex-direction: column; gap: 30px;
  }

  .ad-section-right {
    flex: 0 0 713px; max-width: 713px; position: relative;
  }

  .ad-para-first {
    font-size: 16px; font-weight: 400;
    color: #000000; line-height: 160%;
    margin-top: 192px;
  }
  .ad-para-first1 {
    font-size: 16px; font-weight: 400;
    color: #000000; line-height: 160%;
    margin-top: 220px;
  }
  .ad-para {
    font-size: 16px; font-weight: 400;
    color: #000000; line-height: 160%;
  }
  .ad-para-red {
    font-size: 16px; font-weight: 400;
    color: #EB2019; line-height: 160%;
  }
  .ad-para-italic-red {
    font-size: 16px; font-weight: 400; font-style: italic;
    color: #EB2019; line-height: 160%;
  }

  .ad-main-img {
    width: 100%; height: 500px;
    object-fit: cover; border-radius: 10px;
    display: block; margin-bottom: 20px;
  }

  .ad-thumbs {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px;
  }
  .ad-thumbs img {
    width: 100%; height: 100px;
    object-fit: cover; border-radius: 4px; display: block;
    cursor: pointer; transition: opacity 0.2s, outline 0.2s;
  }
  .ad-thumbs img:hover { opacity: 0.85; }
  .ad-thumbs img.active-thumb { outline: 2px solid #EB2019; }

  /* ══════════════════════════════════════════
     3. SMART BORDERS
  ══════════════════════════════════════════ */
  .ad-smart-section { padding: 80px 0 80px 0; }

  /* ══════════════════════════════════════════
     4. REFLEX
  ══════════════════════════════════════════ */
  .ad-reflex-section { padding: 0 0 80px 0; }
  .ad-reflex-top {
    display: flex; align-items: flex-start; gap: 64px; padding-bottom: 0px; align-items: center;
  }
  .ad-reflex-diagram-wrap {
    flex: 0 0 713px; max-width: 713px;
    display: flex; flex-direction: column; gap: 20px;
  }
  .ad-reflex-diagram-img { width: 100%; height: 475px; object-fit: contain; display: block; }
  .ad-reflex-top-right {
    flex: 1 1 0; display: flex; flex-direction: column; gap: 20px; 
  }
  .ad-reflex-red-text { font-size: 18px; font-weight: 600; color: #EB2019; line-height: 140%; }
  .ad-reflex-para { font-size: 16px; font-weight: 400; color: #000000; line-height: 160%; }
  .ad-reflex-bottom {
    display: flex; align-items: center; gap: 108px;
    padding-top: 60px; padding-bottom:80px; border-bottom:1px solid #EB2019;
  }
  .ad-reflex-bottom-left { flex: 1 1 0; display: flex; flex-direction: column; gap: 20px; }
  .ad-reflex-bottom-red { font-size: 18px; font-weight: 600; font-style: italic; color: #EB2019; line-height: 140%; }
  .ad-reflex-box-wrap { flex: 0 0 541px; max-width: 541px; }
  .ad-reflex-box-img { width: 100%; height: auto; object-fit: contain; display: block; }

  /* ══════════════════════════════════════════
     5. THIRD EYE
  ══════════════════════════════════════════ */
  .ad-thirdeye-section { padding: 0 0 80px 0; }
  .ad-thirdeye-ending {
    font-size: 16px; font-weight: 500;
    color: #202020; line-height: 160%; margin-top: 8px;
  }

  /* ══════════════════════════════════════════
     6. SECOND SIGHT
  ══════════════════════════════════════════ */
  .ad-secondsight-section { padding: 0 0 80px 0; }
  .ad-secondsight-intro { font-size: 20px; font-weight: 400; color: #202020; line-height: 170%; margin-bottom: 20px; }
  .ad-secondsight-desc { font-size: 16px; font-weight: 400; color: #202020; line-height: 180%; margin-bottom: 60px; }
  .ad-secondsight-sub { font-size: 20px; font-weight: 700; color: #202020; letter-spacing: 0.04em; text-transform: uppercase; margin-bottom: 20px; }
  .ad-secondsight-sub-desc { font-size: 16px; font-weight: 400; color: #202020; line-height: 180%; margin-bottom: 32px; }
  .ad-ss-grid {
    display: grid; grid-template-columns: repeat(3, 1fr);
    gap:30px; border-bottom:1px solid #EB2019; padding: 0 0 80px 0;
  }
  .ad-ss-card {
    padding: 30px; background:#F2F5FA;
    display: flex; flex-direction: column; gap: 20px; border-radius:10px;
  }
  .ad-ss-card.full-width { grid-column: 1 ; }
  .ad-ss-card-title { font-size: 20px; font-weight: 600; color: #202020; line-height: 120%; }
  .ad-ss-card-text { font-size: 16px; font-weight: 400; color: #202020; line-height: 160%; }

  /* ══════════════════════════════════════════
     7. ADOR DWEEP
  ══════════════════════════════════════════ */
  .ad-dweep-section { padding: 0 0 80px 0; }

  /* ══════════════════════════════════════════
     8. SPECIALIZED POWER SOURCES
  ══════════════════════════════════════════ */
  .ad-power-section { padding: 0 0 120px 0; }
  .ad-power-label { font-size: 16px; font-weight: 600; color: #202020;}
  .ad-power-val { font-size: 16px; font-weight: 400; color: #202020; line-height: 160%; }
  .ad-power-group { display: flex; flex-direction: column; gap: 15px; }

  .ad-power-right {
    flex: 0 0 713px; max-width: 713px; position: relative;
  }
  .ad-power-carousel { position: relative; overflow: hidden; border-radius: 10px; margin-bottom: 20px; }
  .ad-power-carousel-track { display: flex; transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1); }
  .ad-power-main-img { width: 100%; height: 500px; object-fit: cover; flex: 0 0 100%; display: block; }
  .ad-power-thumbs {
    display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px; margin-bottom: 16px;
  }
  .ad-power-thumbs img {
    width: 100%; height: 100px; object-fit: cover; border-radius: 4px; display: block;
    cursor: pointer; transition: opacity 0.2s, outline 0.2s;
  }
  .ad-power-thumbs img:hover { opacity: 0.85; }
  .ad-power-thumbs img.active-thumb { outline: 2px solid #EB2019; }
  .ad-power-dots { display: flex; align-items: center; justify-content: center; gap: 6px; }
  .ad-power-dot {
    width: 8px; height: 8px; border-radius: 50%; background: #E0E0E0;
    cursor: pointer; border: none; transition: background 0.2s, transform 0.2s;
  }
  .ad-power-dot.active { background: #EB2019; transform: scale(1.25); }

  /* ══════════════════════════════════════════
     RESPONSIVE — TABLET (max-width: 768px)
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .ad-hero             { height: 350px; }
    .ad-hero-content     { padding: 0 32px; }
    .ad-hero-title       { font-size: 30px; }
    .ad-hero-divider     { width: 100%; max-width: 575px; }
    .ad-breadcrumb-inner { padding: 0 32px; }
    .ad-inner            { padding: 0 32px; }
    .ad-subnav           { top: 70px; }
    .ad-subnav-inner     { padding: 0 16px; overflow-x: auto; }
    .ad-subnav-link      { padding: 16px 14px; font-size: 13px; }
    .ad-anchor           { scroll-margin-top: 150px; }
    .ad-smart-section,
    .ad-thirdeye-section { padding: 40px 0; }
    .ad-section-heading  { font-size: 24px; margin-bottom: 24px; }
    .ad-reflex-section   { padding: 0 0 0px 0; }
    .ad-section-row      { padding-bottom: 40px; }
    .ad-secondsight-desc { margin-bottom: 32px; }

    .ad-section-row,
    .ad-reflex-top,
    .ad-reflex-bottom    { flex-direction: column-reverse; gap: 32px; align-items:center; }
    .ad-reflex-box-img   { height: 400px; }
    .ad-reflex-bottom    { padding-top: 16px; padding-bottom: 40px; }

    .ad-section-right,
    .ad-power-right      { flex: none; max-width: 100%; }

    .ad-reflex-diagram-wrap,
    .ad-reflex-box-wrap  { flex: none; max-width: 100%; }

    .ad-overlay-box {
      position: static;
      left: auto; right: auto; margin-top: 0;
      width: 100%; max-width: 100%;
      font-size: 18px; padding: 20px;
    }
    .ad-para-first       { margin-top: 0; }
    .ad-para-first1      { margin-top: 0; }

    .ad-main-img         { height: 320px; }
    .ad-thumbs img       { height: 80px; }
    .ad-power-main-img   { height: 320px; }
    .ad-power-thumbs img { height: 80px; }

    .ad-ss-grid          { grid-template-columns: repeat(2, 1fr); padding: 0 0 40px 0; }
    .ad-secondsight-section { padding: 0 0 40px 0; }
    .ad-dweep-section    { padding: 0 0 40px 0; }
    .ad-ss-card.full-width { grid-column: 1 / -1; }
    .ad-power-section    { padding: 0 0 40px 0; }
  }

  /* ══════════════════════════════════════════
     RESPONSIVE — MOBILE (max-width: 480px)
  ══════════════════════════════════════════ */
  @media (max-width: 480px) {
    .ad-hero             { height: 360px; }
    .ad-hero-content     { padding: 0 16px; }
    .ad-hero-title       { font-size: 24px; }
    .ad-hero-divider     { width: 100%; }
    .ad-breadcrumb       { padding: 24px 0 0 0; }
    .ad-breadcrumb-inner { padding: 0 16px; }
    .ad-bc-item          { font-size: 14px; gap: 8px; }
    .ad-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .ad-inner            { padding: 0 16px; }
    .ad-subnav           { display: none; }
    .ad-mobile-bar       { display: flex; height: 46px; }
    .ad-sidebar-header   { height: 46px; }
    .ad-anchor           { scroll-margin-top: 140px; }
    .ad-subnav-link      { padding: 14px; font-size: 12px; }
    .ad-smart-section    { padding: 60px 0 30px 0; }
    .ad-section-heading  { font-size: 20px; margin-bottom: 30px; }
    .ad-section-row      { align-items: center; gap: 16px; padding-bottom: 30px; }
    .ad-reflex-top       { flex-direction: column; gap: 15px; }
    .ad-section-left     { gap: 15px; }
    .ad-reflex-diagram-img { height:auto; }
    .ad-reflex-red-text  { font-size: 14px; }
    .ad-reflex-top-right { gap: 15px; }
    .ad-reflex-para      { font-size: 14px; }
    .ad-reflex-bottom    { padding-top: 30px; padding-bottom: 30px; }
    .ad-reflex-bottom-red { font-size: 14px; }
    .ad-reflex-bottom-left { gap: 15px; }
    .ad-reflex-section   { padding: 0 0 30px 0; }
    .ad-thirdeye-section { padding: 0 0 30px 0; }
    .ad-section-heading1 { font-size: 20px; margin-bottom: 30px; }
    .ad-secondsight-intro { font-size: 16px; margin-bottom: 15px; }
    .ad-secondsight-desc { font-size: 14px; margin-bottom: 60px; }
    .ad-secondsight-sub  { font-size: 16px; margin-bottom: 15px; }
    .ad-secondsight-sub-desc { font-size: 14px; margin-bottom: 30px; }
    .ad-ss-card          { padding: 20px; gap: 15px; }
    .ad-ss-card-title    { font-size: 16px; }
    .ad-ss-card-text     { font-size: 14px; }

    .ad-overlay-box      { font-size: 14px; }
    .ad-para-first,
    .ad-para,
    .ad-para-red,
    .ad-para-italic-red  { font-size: 14px; }
    .ad-para-first       { margin-top: 0; }
    .ad-para-first1      { margin-top: 0; }

    .ad-main-img         { height: 220px; width:370px; }
    .ad-thumbs           { gap: 17px; grid-template-columns: repeat(4, 1fr); }
    .ad-thumbs img       { height: 50px; }

    .ad-power-main-img   { height: 220px; }
    .ad-power-thumbs     { gap: 17px; grid-template-columns: repeat(4, 1fr); }
    .ad-power-thumbs img { height: 50px; }

    .ad-ss-grid          { grid-template-columns: 1fr; gap:20px; padding: 0 0 30px 0; }
    .ad-secondsight-section { padding: 0 0 30px 0; }
    .ad-ss-card.full-width { grid-column: 1 / 1; }
    .ad-dweep-section    { padding: 0px 0 30px 0px !important; }
    .ad-power-section    { padding: 0px 0 60px 0px !important; }
  }
`;

const secondSightCards = [
  { title: "Digital High Definition Video Cameras", text: "Such Cameras May Or May Not Have Edge Analytics Based On The Level Of Sophistication Demanded By The Mission. Cameras Are Typically Linked So That A Seamless Handover Occurs From One Camera To Another When A Subject Moves Outside Its Pan, Tilt Or Zoom Capability (I.E. A Set Of Cameras All Talk To Each Other Autonomously Knowing Where To Look And When). High Definition Cameras, Including Those That Can See In Full Colour In Zero Lux At Night Are Manufactured By ADOR In India." },
  { title: "Radar", text: "In Addition To The Integrated Equipment Above, A High Level Perimeter Protection System Will Often Employ Radar To Detect Movement Close To The Perimeter Fence Or Inside A Particular Perimeter Area, Identifying Movement Of Objects And Informing Cameras Where Pan, Tilt, Zoom And Focus. Radar Systems Can Also Be Integrated Using RFID To Deploy Identify Friend Or Foe (IFF) Technology As Well. Ability To Function In Extreme Weather Conditions Of Fog And Snow." },
  { title: "Long Range Cameras", text: "Depending On The Size Of The Base And The Terrain - Sometimes A Long Range Camera Which Can See 5 Kms In The Day And 3 Kms At Night Or 1 Km In Fog Maybe Deployed As Well. Such Cameras In Essence Act As Heavy Duty Binoculars And Are Triggered When Any Of The Sensors Above Have Detected A Threat, Proven As Not A False Alarm And The Threat Is In An Area Not Very Well Covered By Existing Cameras. Ideally Located On High Points Such As An Air Traffic Control (ATC) Tower, These Cameras Provide Maximum Visibility In Adverse Conditions From A High Vantage Point. Ador Manufactures Long Range 5km Cameras In India." },
  { title: "Unattended Sensors", text: "An Unattended Sensor Could Be An Underground Vibration Sensor, An Underwater Movement Sensor Or Any Sensor That Passively Monitors A Given Location / Area And Creates An Alarm When A Change Occurs, Allowing Cameras To Focus On The Area And Run Software Algorithms To Determine The Threat." },
  { title: "Optical Fibre Cables", text: "This Could Be A Political Or Religious Mass Gathering Of People In A Location With Limited Or No CCTV Coverage, A Disaster Situation Such As Earthquake Or Terrorist Strike Where Existing Infrastructure For CCTV Coverage Is Unusable - Or A VIP Visit To Locations With No CCTV Coverage." },
  { title: "Electro Optic (E/O) Sensors", text: "An EO Sensor Is An Integrated Day Night And Thermal Cameras With Pan, Tilt And Zoom System. These Are Capable Of Long Distance Detection (Over 20km), Recognition And Identification Ranges. These Are Capable Of Distinguishing Between Vehicles And Humans." },
  { title: "Aero Stats or Drones", text: "To Provide Long Range Visibility In Day And Night An Aero Stat Or Drone Which Can Operate From 500 Feet To 2000 Feet Can Be Deployed At A Distance From The Sensitive Border, Allowing Continuous CCTV Coverage Whenever Required." },
  { title: "Optical Time Domain Reflectometer", text: "The Condition Of The Fibre Cable Is Monitored Continuously. Any Breakage, Tension, Vibration Is Recognized Immediately Due To The Change In Light Transmission Creating An Alarm Pinpointing The Exact Location Along The Fence." },
  { title: "Anti-Drone", text: "These Solutions Use Radars To Detect Drones, UAVs, Low Flying Objects, Etc And Automatically Focus The EO Sensor Tracking The Target. Solutions Provide Needed Inputs For Interface With Weaponry Systems For Action." },
  { title: "Command and Control Centre", text: "All the sensors and cameras are linked back to a C2 room which is ballistic level II certified. The C2 software determines threats once a sensor has picked up an anomaly, confirms this using inputs from other sensors and then targets a camera capable of acquiring the intrusion risk in the area. Software algorithms can determine the threat confirmed on the relevant camera and escalate this as an alarm to personnel for a decision to be made on the type of response.", fullWidth: true },
];

function ThumbGallery({ images, mainAlt = "" }) {
  const [activeIdx, setActiveIdx] = useState(0);
  const timerRef = React.useRef(null);

  const startTimer = (currentLength) => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActiveIdx(prev => (prev + 1) % currentLength);
    }, 3000);
  };

  React.useEffect(() => {
    startTimer(images.length);
    return () => clearInterval(timerRef.current);
  }, [images.length]);

  const handleThumbClick = (idx) => {
    setActiveIdx(idx);
    startTimer(images.length);
  };

  return (
    <>
      <img className="ad-main-img" src={images[activeIdx]} alt={mainAlt} />
      <div className="ad-thumbs">
        {images.slice(1).map((src, i) => (
          <img
            key={i} src={src} alt=""
            className={activeIdx === i + 1 ? "active-thumb" : ""}
            onClick={() => handleThumbClick(i + 1)}
          />
        ))}
        {images.slice(1).length < 4 &&
          Array.from({ length: 4 - images.slice(1).length }).map((_, i) => (
            <div key={`pad-${i}`} />
          ))
        }
      </div>
    </>
  );
}

function PowerCarousel({ slides }) {
  const [activeDot, setActiveDot] = useState(0);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setActiveDot(prev => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="ad-power-right">
      <div className="ad-power-carousel">
        <div
          className="ad-power-carousel-track"
          style={{ transform: `translateX(-${activeDot * 100}%)` }}
        >
          {slides.map((slide, i) => (
            <img key={i} className="ad-power-main-img" src={slide.main} alt={`Slide ${i + 1}`} />
          ))}
        </div>
      </div>
      <div className="ad-power-thumbs">
        {slides[activeDot].thumbs.map((thumb, i) => (
          <img key={i} src={thumb} alt="" className={i === activeDot ? "active-thumb" : ""} />
        ))}
      </div>
      <div className="ad-power-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`ad-power-dot${activeDot === i ? " active" : ""}`}
            aria-label={`Slide ${i + 1}`}
          />
        ))}
      </div>
    </div>
  );
}

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function AdorDefence() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const smartImages    = [SmartMainImg, SmartThumb1, SmartThumb2, SmartThumb3];
  const thirdEyeImages = [ThirdEyeMainImg, ThirdEyeThumb1, ThirdEyeThumb2, ThirdEyeThumb3, ThirdEyeThumb4];
  const dweepImages    = [DweepMainImg, DweepThumb1, DweepThumb2, DweepThumb3, DweepThumb4];

  return (
    <div className="ad">
      <style>{CSS}</style>

      {/* ══ 1. HERO ══ */}
      <section className="ad-hero">
        <img className="ad-hero-bg" src={HeroBgImg} alt="Ador Defence Hero" />
        <div className="ad-hero-overlay" />
        <div className="ad-hero-content">
          <h1 className="ad-hero-title">Ador Defence</h1>
          <hr className="ad-hero-divider" />
          <p className="ad-hero-subtitle">Ador has been involved with the defence sector for over 20 years</p>
        </div>
      </section>

      {/* ══ STICKY SUBNAV — desktop ══ */}
      <nav className="ad-subnav" aria-label="Defence sections">




        <div className="ad-subnav-inner">
          {NAV_ITEMS.map((item) => (
            <div className="ad-subnav-item" key={item.anchor}>
              <a
                href={`#${item.anchor}`}
                className="ad-subnav-link"
                onClick={(e) => { e.preventDefault(); scrollTo(item.anchor); }}
              >
                {item.label}
              </a>
            </div>
          ))}
        </div>
      </nav>

      {/* ══ MOBILE BAR ══ */}
      <div className="ad-mobile-bar">
        <span className="ad-mobile-bar-title">Ador Defence</span>
        <button className="ad-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
          <span /><span /><span />
        </button>
      </div>

      {/* ══ MOBILE SIDEBAR ══ */}
      <div
        className={`ad-sidebar-overlay${sidebarOpen ? " open" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />
      <div className={`ad-sidebar${sidebarOpen ? " open" : ""}`}>
        <div className="ad-sidebar-header">
          <span className="ad-sidebar-header-title">Ador Defence</span>
          <button className="ad-sidebar-close" onClick={() => setSidebarOpen(false)}>✕</button>
        </div>
        <nav className="ad-sidebar-nav">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.anchor}
              href={`#${item.anchor}`}
              className="ad-sidebar-row"
              onClick={(e) => {
                e.preventDefault();
                setSidebarOpen(false);
                setTimeout(() => scrollTo(item.anchor), 320);
              }}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>

      {/* ══ 2. BREADCRUMB ══ */}
      <nav className="ad-breadcrumb" aria-label="Breadcrumb">
        <div className="ad-breadcrumb-inner">
          <a href="/" className="ad-bc-item">Home</a>
          <span className="ad-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="" className="ad-bc-item">Business</a>
          <span className="ad-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="ad-bc-item active">Ador Defence</span>
        </div>
      </nav>

      {/* ══ 3. SMART BORDERS ══ */}
      <section className="ad-smart-section">
        <div className="ad-inner">
          <div id="ad-smart-borders" className="ad-anchor" />
          <h2 className="ad-section-heading">Smart Borders</h2>
          <div className="ad-section-row">
            <div className="ad-section-left">
              <div className="ad-overlay-box">
                Soon, Border And Perimeter Walls Won't Be Built With Barbed Wires Or Stones But With A Series Of High-Powered Cameras, Defense Systems And Digital Sensors.
              </div>
              <p className="ad-para-first">
                Ador Has Been Involved With The Defence Sector For Over 20 Years Providing Specialised Power Sources, Submarine Battery Chargers, Mil-Grade UPS / DC Systems And Battlefield Deployable Power Sources With Low Heat, Vibration And Electromagnetic Signatures For Mission-Critical Electronics Equipment.
              </p>
              <p className="ad-para">
                Ador Equipment Is Installed On Missile Launchers, Radars, Battlefield Shelters, Command And Control Centers And Submarine Bases.
              </p>
              <p className="ad-para-red">
                India Shares Over 15000 Kilometres Of Its Borders With Its Neighbors. The Terrain Constitutes The Topographic Extremes From Arid Deserts And Swamps, To Snow Covered Himalayas, Rivers And Forests.
              </p>
              <p className="ad-para">
                Protecting Borders From Enemy Insurgents, Smugglers And Terrorists Is An Uphill Task. And This Not A Uniquely Indian Problem. Human Surveillance Alone Cannot Protect And Defend State And National Borders.
              </p>
            </div>
            <div className="ad-section-right">
              <ThumbGallery images={smartImages} mainAlt="Smart Borders Camera" />
            </div>
          </div>
        </div>
      </section>

      

      {/* ══ 5. THIRD EYE ══ */}
      <section className="ad-thirdeye-section">
        <div className="ad-inner">
          <div id="ad-third-eye" className="ad-anchor" />
          <h2 className="ad-section-heading">Third Eye™ Perimeter Protection &amp; Intrusion Detection</h2>
          <div className="ad-section-row">
            <div className="ad-section-left">
              <div className="ad-overlay-box">
                The Third Eye, A Mystical Concept Of An Invisible Eye Which Provides Perception Beyond Ordinary Sight.
              </div>
              <p className="ad-para-first">
                Designed To Protect Defence Bases And Sensitive Government Infrastructure, ADOR's Comprehensive Perimeter Protection And Intrusion Detection System Employs A Host Of Sensors To Allow Cameras To Make Autonomous Decisions Of Where To Pan, Tilt, Zoom And Focus.
              </p>
              <p className="ad-para">
                It Then Uses Software To Then Analyse The Potential Threats To Decide If The Threat Is Hostile, Allowing Personnel In A Command And Control Room To Make Rapid And Informed Decisions To Authorise A Proportional Level Of Response. Solutions Can Distinguish Between Humans And Vehicles.
              </p>
              <p className="ad-para">
                A Typical Control Room Could Have As Many As 200 Screens Monitoring Various Cameras, Through A Comprehensive Perimeter Protection System. Inputs From Multiple Sensors, Devices And Cameras Are Used To Analyse Alarms, Make A Threat Level Assessment And Alert Security Teams.
              </p>
              <p className="ad-para">
                The System Includes Passive And Active Imaging, Radar, Underground Sensors, Underwater Sensor, Drone Based Cameras And Optical Fibre Sensors.
              </p>
              <p className="ad-thirdeye-ending">
                A Perimeter Protection And Intrusion Detection System Will Typically Include
              </p>
            </div>
            <div className="ad-section-right">
              <ThumbGallery images={thirdEyeImages} mainAlt="Third Eye System" />
            </div>
          </div>
        </div>
      </section>

      {/* ══ 6. SECOND SIGHT ══ */}
      <section className="ad-secondsight-section">
        <div className="ad-inner">
          <div id="ad-second-sight" className="ad-anchor" />
          <h2 className="ad-section-heading1">Second Sight™ Smart Border Protection</h2>
          <p className="ad-secondsight-intro">Second Sight, An Intuitive Power Of Perception That Transcends The Other Five Senses.</p>
          <p className="ad-secondsight-desc">
            Designed To Protect Sensitive Borders That Face Repeated Incursions From Hostile Forces, Ador's Second Sight™ Smart Border Protection Solutions Incorporates A Host Of Sensor Based Technologies To Allow Cameras To Acquire And Detect Threats In A More Focused And Autonomous Manner, Escalating Alarms To Command And Control Centres Once A Threat Has Been Confirmed. These Solutions Can Distinguish Between Humans And Machine Intrusions.
          </p>
          <p className="ad-secondsight-sub">SECOND SIGHT™ SMART BORDER SOLUTIONS</p>
          <p className="ad-secondsight-sub-desc">
            These Solutions Can Be Deployed With Or Without A Physical Border Fence In Place. The Smart Border Solution Typically Includes:
          </p>
          <div className="ad-ss-grid">
            {secondSightCards.map((card, idx) => (
              <div className={`ad-ss-card${card.fullWidth ? " full-width" : ""}`} key={idx}>
                <p className="ad-ss-card-title">{card.title}</p>
                <p className="ad-ss-card-text">{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      

      {/* ══ 8. SPECIALIZED POWER SOURCES ══ */}
      <section className="ad-power-section">
        <div className="ad-inner">
          <div id="ad-specialized-power" className="ad-anchor" />
          <h2 className="ad-section-heading">Specialized Power Sources</h2>
          <div className="ad-section-row">
            <div className="ad-section-left">
              <div className="ad-overlay-box">
                Ador has supplied the defence sector for over 15 years with specialised Mil-Grade power sources, power back up products, specialised power electronics and battery charging and testing equipment.
              </div>
              <p className="ad-para-first1">
                Ador has supplied the defence sector for over 15 years with specialised Mil-Grade power sources, power back up products, specialised power electronics and battery charging and testing equipment.
              </p>
              <div className="ad-power-group">
                <p className="ad-power-label">Clients</p>
                <p className="ad-power-val">Larsen &amp; Tubro, DRDO, BEL, LRDE, CEC, USA, DH Limited.</p>
              </div>
              <div className="ad-power-group">
                <p className="ad-power-label">Projects</p>
                <p className="ad-power-val">Missile Launcher, Radars, Inflatable Shelters, Command And Control Shelters, Marine, Submarine Battery Chargers, Etc.</p>
              </div>
              <div className="ad-power-group">
                <p className="ad-power-label">Specs</p>
                <p className="ad-power-val">
                  Mil Grade UPS / DC / FCBC Power Sources Conform To EMI/EMC - ML 461 E/F; Environmental - JSS 55555 / MIL 810; Temperature - 30 / -20 / -10 To +55°C, Isolation Transformers For Marine Applications, VLF Transmitters.
                </p>
              </div>
            </div>
            <PowerCarousel slides={powerSlides} />
          </div>
        </div>
      </section>

    </div>
  );
}